<ng-container *ngIf="loading$ | async"> <ish-loading [fullPage]="true"></ish-loading> </ng-container
><button
  type="submit"
  name="addProduct"
  [ngClass]="cssClass"
  (click)="openModal(modal)"
  data-testing-id="addBasketToWishListButton"
>
  {{ 'account.wishlist.create.heading' | translate }}
</button>
<ish-wishlist-preferences-dialog
  #modal
  modalTitle="account.wishlist.create.heading"
  (submitWishlist)="createWishList($event)"
></ish-wishlist-preferences-dialog>
